import { render } from "./DynamicHeighVideoContainer.vue?vue&type=template&id=42827af6"
import script from "./DynamicHeighVideoContainer.vue?vue&type=script&lang=js"
export * from "./DynamicHeighVideoContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__